import * as CloudRender from "@/types/CloudRenderMap.js";
import { IResultCloudRender, ICenterLevel, IAssetModel, IResult, RemoveAss, IOverlayParameter, IOverlayDelete } from "@/types/map";
export default class MapApp {
    private viewer!: any;

    public mapClick!: (event: any) => void;
    public markerClick!: (event: any) => void;
    public markerMouseMove!: (event: any) => void;
    public markerMouseIn!: (event: any) => void;
    public markerMouseOut!: (event: any) => void;
    /**
     * 地图初始化
     * 加载依赖文件，解析配置参数，初始化viewer对象
     */
    public async init(elementId: string, mapConfig: any, callback: Function): Promise<any> {
        let CloudRenders: any = (CloudRender as any).default;
        console.log(CloudRenders, 1112);
        let initObj = {
            // 创建 id=player
            renderType: mapConfig.options.renderType, // 设置渲染类型
            token: mapConfig.options.token, // 许可密钥
            coordType: mapConfig.options.coordType, // 坐标类型(0:经纬度坐标，1:cad 坐标)
            center: mapConfig.options.center, //中心点经纬度坐标 lng,lat
            signallingSocket: mapConfig.signallingSocket, // 信令websocket地址连接后自动分配视频流websocket地址
            defaultCamera: {
                // 默认机位
                cameraId: mapConfig.options.cameraId, // camera的id （唯一）
                coordType: mapConfig.options.coordType, //坐标类型(0:经纬度坐标，1:cad坐标)
                coordZ: mapConfig.options.coordZ, //高度(单位:米)
                center: mapConfig.options.center, // 中心点坐标 [lng,lat]
                rotation: mapConfig.options.rotation, // [偏航,俯仰,翻滚]   [ 翻滚,俯仰,偏航]
                armDistance: mapConfig.options.armDistance, // ue 臂长
                fly: mapConfig.options.fly, //是否使用飞行动画(true:使用；false:不使用)
                flyTime: mapConfig.options.flyTime, //飞行动画时长(单位:秒)，默认为2秒
                isDefault: mapConfig.options.isDefault, // 是否 是默认机位 （唯一）
            },
        };
        const world3d = new CloudRenders.Scene(document.getElementById(elementId), initObj, callback);
        console.log(world3d, 1111);

        this.viewer = world3d;
        return new Promise<void>(resolve => {
            resolve(world3d);
        });
    }
    public async setWebsocket(): Promise<any> {
        return this.viewer;
    }
    /**
     * setCameraInfo
     * 调整摄像机相机信息
     */
    public async setCameraInfo(params: any): Promise<IResultCloudRender> {
        let result: IResultCloudRender = await this.viewer.setCameraInfo(params);
        return result;
    }
    /**
     * performExtendAction
     * 8自定义扩展接口
     */
    public async performExtendAction(params: any): Promise<IResultCloudRender> {
        let result: IResultCloudRender = await this.viewer.performExtendAction(params);
        return result;
    }
    /**
     * setMapCenterAndLevel
     * 调整摄像机位置
     */
    public async setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
        console.log(this.viewer, 112);
        let param = {
            // 3D参数
            // camera的id（唯一）
            cameraId: params.cameraId,
            //坐标类型(0:经纬度坐标，1:cad坐标)
            coordType: params.coordType,
            //高度(单位:米)
            coordZ: params.coordZ,
            // 中心点坐标 [lng,lat]
            center: [params.x, params.y],
            // ue 臂长
            armDistance: params.armDistance,
            // [翻滚,俯仰,偏航]
            rotation: params.rotation,
            //是否使用飞行动画(true:使用；false:不使用)
            fly: params.fly,
            //飞行动画时长(单位:秒)，默认为2秒
            flyTime: params.flyTime,
        };
        return await this.viewer.setCameraInfo(param);
    }
    /**
     * addAssetModel
     * 添加单个模型
     */
    public async addAssetModel(params: IAssetModel): Promise<IResult> {
        return await this.viewer.addAssetModel(params);
    }
    /**
     * removeAssetModel
     * 删除单个模型
     */
    public async removeAssetModel(params: RemoveAss): Promise<IResult> {
        return await this.viewer.removeAssetModel(params);
    }
    /**
     * addMarkers
     * 添加自定义点位
     */
    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        return await this.viewer.addMarkers(params);
    }
    /**
     * removeMarkers
     * 删除自定义点位
     */
    public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        return await this.viewer.removeMarkers(params);
    }
    public async closeClientWebsocket(): Promise<void> {
        return await this.viewer.closeClientWebsocket();
    }
}
